<template>
    <div class="main">
        <div class="app-name">
            <rich-logo></rich-logo>
            <div>
                <h2>Rich'en Danse</h2>
                <p>Espace membre</p>
            </div>
        </div>
        <div class="connexion container">
            <div>
                <h1>Bonjour {{user.firstname}}, <br> Remplis les champs suivants afin de valider ton
                    compte.</h1>
                <ValidationObserver ref="observer"
                                    v-slot="{ invalid }"
                                    tag="form"
                                    @submit.prevent="createAdmin()"
                                    class="form-container"
                >
                    <uni-input-container label="Rue" for="rue">
                        <uni-input rules="required"
                                   v-model="user.street"
                                   id="rue"
                        />
                    </uni-input-container>
                    <uni-input-container label="Code postal" for="postal">
                        <uni-input rules="required"
                                   v-model="user.postal_code"
                                   id="postal"
                        />
                    </uni-input-container>
                    <uni-input-container label="Ville" for="city">
                        <uni-input rules="required"
                                   v-model="user.city"
                                   id="city"
                        />
                    </uni-input-container>
                    <uni-input-container label="Téléphone" for="tel">
                        <uni-input rules="required|digits:10"
                                   v-model="user.tel"
                                   type="tel"
                                   id="tel"
                        />
                    </uni-input-container>
                    <ValidationProvider
                            name="password"
                            rules="required|passwordCheck"
                            v-slot="{ errors }"
                    >
                        <uni-input-container label="Mot de passe" id="password">
                            <uni-input-password v-model="family.password" id="password"/>
                        </uni-input-container>
                        <span class="message-error">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                            rules="required|confirmed:password"
                            v-slot="{ errors }"
                    >
                        <uni-input-container label="Confirmez le mot de passe" id="confirm">
                            <uni-input-password v-model="family.password_confirmation" id="confirm"/>
                        </uni-input-container>
                        <span class="message-error">{{ errors[0] }}</span>

                    </ValidationProvider>
                    <uni-loading-button class="full-width" :is-disable="loadingButton"
                                        text="Créer mon compte"></uni-loading-button>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
    import RichLogo from "../../components/a-elements/RichLogo";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import InputBirthday from "../../components/a-elements/InputBirthday";
    import UniButton from "../../components/a-elements/UniButton";
    import UniInput from "../../components/a-elements/UniInput";
    import {mapGetters} from "vuex";
    import UniInputPassword from "../../components/a-elements/UniInputPassword";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

    export default {
        name: "adminConfirm",
        components: {
            UniLoadingButton,
            UniInputPassword,
            UniInput,
            UniButton,
            InputBirthday,
            UniInputContainer,
            RichLogo
        },
        computed: {
            ...mapGetters({currentFamily: 'currentFamily'})
        },
        data() {
            return {
                loadingButton: false,
                family: {
                    password: '',
                    password_confirmation: '',

                },
                user: {
                    street: '',
                    postal_code: '',
                    city: '',
                    tel: '',

                }
            }
        },
        methods: {
            async createAdmin() {
                this.loadingButton = true
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    this.loadingButton = false
                } else {
                    let obj = {
                        family: {
                            ...this.family,
                            users_attributes: {
                                0: {
                                    ...this.user
                                }
                            }
                        }
                    }
                    this.$http.put('/admin/admins/' + this.$route.query.admin_id + '/confirm?admin_id=' + this.$route.query.admin_id + '&token=' + this.$route.query.token, obj)
                        .then(response => {
                            this.loadingButton = false
                            this.$router.push({name: 'Login', params: {admin: 'true'}})

                        })
                        .catch(err => {
                            if (this.$isSignatureExpired(err.response.data.message)) {
                                this.$store.dispatch('logout')
                                this.$router.push({name: 'Login', params: {q: 'expired'}})
                            }
                        })
                }
            }
        },
        created() {
            if (this.currentFamily) {
                this.$router.push('/')
            } else {
                this.$http.get('/admin/admins/' + this.$route.query.admin_id + '/get-family')
                    .then(response => {
                        this.user = response.data.users[0]
                    })
                    .catch(error => {
                        if (this.$isSignatureExpired(error.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            }
        }

    }
</script>

<style lang="scss" scoped>
    .main {
        height: 100vh;
    }


    .connexion {
        max-width: 450px;
        width: 100%;
        margin: 0 auto;
        background: var(--surface-color-light);

        h1 {
            margin-bottom: var(--s-xl);
        }

        &__new {
            margin-top: var(--s-xxl);
            text-align: center;
        }
    }

    .pub {
        display: none;
    }

    .app-name {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        padding: 8px;

        > div {
            p {
                margin-bottom: 0;
            }

            h2 {
                line-height: 16px;
                margin-bottom: 0;
            }
        }
    }

    .pub-uni {
        position: fixed;
        padding: 8px;
    }

    @include screen-xs {
        .pub-uni {
            padding: 16px;
        }
        .app-name {
            padding: 16px;
        }
    }

    @include screen-l {
        .main {
            .pub-uni {
                bottom: 24px;
                padding: 16px 24px;
            }
        }

        .app-name {
            margin-bottom: 84px;
            padding: 16px 24px;
        }

    }
</style>
